export function rehydrateMapData(data, models) {
  return data.map(function (datum) {
    const country = models.countries.get(datum.countryId);

    if (!country) {
      console.warn('Missing country data', datum.countryId);
    }

    return {
      ...datum,
      country: country,
    };
  });
}
